module.exports = __webpack_public_path__ + "img/index_banner_new.e27353d4.png";